import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
}
export default function ServiceCard({
  title,
  description,
  icon,
  link
}: ServiceCardProps) {
  return <div className="bg-white rounded-lg shadow-md p-6 transition-all hover:shadow-xl border-t-4 border-primary card-lift group" data-id="element-343">
      <div className="text-primary mb-4 transform transition-transform group-hover:scale-110 group-hover:rotate-3" data-id="element-344">
        {icon}
      </div>
      <h3 className="text-xl font-serif font-bold text-primary mb-2 group-hover:text-secondary transition-colors" data-id="element-345">
        {title}
      </h3>
      <p className="text-slate mb-4 leading-relaxed" data-id="element-346">{description}</p>
      <Link to={link} className="inline-flex items-center text-primary font-medium hover:text-secondary transition-all group-hover:translate-x-2" data-id="element-347">
        Read More <ArrowRight className="ml-1 h-4 w-4" data-id="element-348" />
      </Link>
    </div>;
}